module.exports = __webpack_public_path__ + "bz.svg?ca77ff979e4e7e33ff61bf2996c3a7b1";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/bz.svg
// module id = 1212
// module chunks = 27